export const SOCIALS = {
  github: 'https://github.com/nanafox',
  twitter: 'https://x.com/the_nanafox',
  linkedin: 'https://linkedin.com/in/maxwellnanaforson',
  youtube: 'https://www.youtube.com/@thelazyprogrammer_',
} as const;
